import { FormInputBase } from './form-input-base';

export class FormCascade extends FormInputBase<string> {
    override controlType = 'cascade';
}
